import { render } from "./SuggestionsPanel.vue?vue&type=template&id=5fe664ec&scoped=true"
import script from "./SuggestionsPanel.vue?vue&type=script&lang=js"
export * from "./SuggestionsPanel.vue?vue&type=script&lang=js"

import "./SuggestionsPanel.vue?vue&type=style&index=0&id=5fe664ec&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fe664ec"]])

export default __exports__